import React, { useState, useEffect } from 'react'
import {
  Alert,
  Button,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Table,
  Row,
  Input,
} from 'reactstrap'
import moment from 'moment'
import { RESPONSE_PURCHASE_DATA, SMS_TEXTS_PURCHASE_DATA } from '../data'
import axios from '../../../axios'
import * as url from '../../../utils/url'
import { toastContainer } from '../../../utils/toast'
import PlusMinusInput from '../../../components/PlusMinusInput/PlusMinusInput'
import { loadStripe } from '@stripe/stripe-js'
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from '@stripe/react-stripe-js'
import TrivvyResponseCounter from './TrivvyResponseCounter'
import { STRIPE_PUBLIC_KEY } from '../../../utils/constants'
import TrivvySmsCounter from './TrivvySmsCounter'
// const stripePromise = loadStripe(
//   "pk_test_51OJwd9SFK2fFH6SpHruYb7TzxbFjOPIHFgmXMPCcOy4dDy5C0z3gnTVVUPZgaSt0CmBVHmj1ZnaHn1VCYfZ4RrIH00FQJTB5sm"
// );
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY)

export default function ResponsePurchaseModal({
  open,
  onClose,
  orgChangeSuccess,
  showResponseTable = true,
}) {
  const [tableData, setTableData] = useState(
    JSON.parse(JSON.stringify(RESPONSE_PURCHASE_DATA))
  )
  const [tableDataSms, setTableDataSms] = useState(
    JSON.parse(JSON.stringify(SMS_TEXTS_PURCHASE_DATA))
  )
  const [cartData, setCartData] = useState([])
  const [clientSecret, setClientSecret] = useState(null)
  const [
    responsePurchaseCallbackData,
    setResponsePurchaseCallbackData,
  ] = useState(null)
  const [paymentSuccess, setPaymentSuccess] = useState(false)

  const [response_purchase_id, setResponse_purchase_id] = useState(null)
  const managePurchase = () => {
    axios
      .post(url.createStripeCheckout(), {
        lineItems: cartData,
      })
      .then(({ data }) => {
        const result = data.data
        setClientSecret(result.clientSecret)
        setResponse_purchase_id(result.purchaseId)
      })
      .catch((err) => {
        toastContainer('Error while Generating Invoice', 'error')
      })
  }

  const handleQuantityChanges = (quantity, index) => {
    const items = [...tableData]
    console.log('fire', index)

    items[index]['quantity'] = quantity

    setTableData(items)

    let cartArray = [...cartData]

    for (const item of items) {
      if (item.quantity > 0) {
        const extIndex = cartArray.findIndex((c) => c.priceId == item.priceId)
        if (extIndex >= 0) {
          cartArray[extIndex] = {
            priceId: item.priceId,
            price: item.price,
            quantity: item.quantity,
            responses: item.responses,
          }
        } else {
          console.log('endd')
          cartArray.push({
            priceId: item.priceId,
            price: item.price,
            quantity: item.quantity,
            responses: item.responses,
          })
        }
      } else {
        const extIndex = cartArray.findIndex((c) => c.priceId == item.priceId)
        if (extIndex >= 0) {
          cartArray.splice(extIndex, 1)
        }
      }
    }
    setCartData([...cartArray])
  }
  const handleQuantityChangesSms = (quantity, index) => {
    const items = [...tableDataSms]
    items[index]['quantity'] = quantity

    setTableDataSms(items)

    let cartArray = [...cartData]

    for (const item of items) {
      if (item.quantity > 0) {
        const extIndex = cartArray.findIndex((c) => c.priceId == item.priceId)
        if (extIndex >= 0) {
          cartArray[extIndex] = {
            priceId: item.priceId,
            price: item.price,
            quantity: item.quantity,
            smsTexts: item.smsTexts,
          }
        } else {
          console.log('endd')
          cartArray.push({
            priceId: item.priceId,
            price: item.price,
            quantity: item.quantity,
            smsTexts: item.smsTexts,
          })
        }
      } else {
        const extIndex = cartArray.findIndex((c) => c.priceId == item.priceId)
        if (extIndex >= 0) {
          cartArray.splice(extIndex, 1)
        }
      }
    }
    setCartData([...cartArray])
  }

  const getTotalResponses = () => {
    let total = 0

    for (const item of cartData) {
      if (item.quantity > 0 && item.hasOwnProperty('responses')) {
        total += item.quantity * item.responses
      }
    }

    return total
  }
  const getTotalSmsTexts = () => {
    let total = 0

    for (const item of cartData) {
      if (item.quantity > 0 && item.hasOwnProperty('smsTexts')) {
        total += item.quantity * item.smsTexts
      }
    }

    return total
  }

  const getTotalAmount = () => {
    let total = 0

    for (const item of cartData) {
      if (item.quantity > 0) {
        total += item.quantity * item.price
      }
    }

    return total
  }

  const runAfterPayment = () => {
    setClientSecret(null)
    if (response_purchase_id) {
      setPaymentSuccess(true)

      axios
        .get(url.handlePurchaseSuccess(response_purchase_id))
        .then(({ data }) => {
          const result = data.data

          orgChangeSuccess(result.org)

          setResponsePurchaseCallbackData({
            success: true,
            ...result.purchase,
          })
        })
        .catch((err) => {
          toastContainer('Error while increasing response limit', 'error')

          setResponsePurchaseCallbackData({
            success: false,
            message:
              'Your payment was succesfull but error occured while adding the purchsed responses limit for your organization.',
          })
          console.log(err)
        })
    }
  }

  const handleComplete = () => {
    return setPaymentSuccess(true)
  }

  useEffect(() => {
    if (paymentSuccess) {
      runAfterPayment()
    }
  }, [paymentSuccess])

  return (
    <Modal isOpen={open}>
      <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>
        Manage Credits
      </ModalHeader>
      <ModalBody>
        {clientSecret && !paymentSuccess ? (
          <EmbeddedCheckoutProvider
            stripe={stripePromise}
            options={{ clientSecret, onComplete: handleComplete }}>
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        ) : (
          <div className="">
            {paymentSuccess && (
              <div>
                {' '}
                {responsePurchaseCallbackData && (
                  <div className="my-2">
                    {responsePurchaseCallbackData.success ? (
                      <Alert color="success">
                        Your payment was successful and you have purchased
                        {responsePurchaseCallbackData.numberOfResponsesPurchased >
                          0 && ' responses'}{' '}
                        {responsePurchaseCallbackData.numberOfSmsTextPurchased >
                          0 &&
                        responsePurchaseCallbackData.numberOfResponsesPurchased >
                          0
                          ? 'and'
                          : ''}{' '}
                        {responsePurchaseCallbackData.numberOfSmsTextPurchased >
                          0 && 'sms texts'}{' '}
                        successfully.
                        <Row className="mt-3">
                          {responsePurchaseCallbackData.numberOfResponsesPurchased ? (
                            <Col sm={6}>
                              Responses Purchased:{' '}
                              {
                                responsePurchaseCallbackData.numberOfResponsesPurchased
                              }{' '}
                            </Col>
                          ) : (
                            ''
                          )}

                          {responsePurchaseCallbackData.numberOfSmsTextPurchased ? (
                            <Col sm={6}>
                              SMS Text Purchased:{' '}
                              {
                                responsePurchaseCallbackData.numberOfSmsTextPurchased
                              }{' '}
                            </Col>
                          ) : (
                            ''
                          )}

                          <Col sm={6}>
                            Total Amount : $
                            {responsePurchaseCallbackData.paymentAmount}
                          </Col>
                          <Col sm={6}>
                            Currency:{' '}
                            {responsePurchaseCallbackData.paymentCurrency
                              ? responsePurchaseCallbackData.paymentCurrency.toUpperCase()
                              : 'USD'}{' '}
                          </Col>
                          <Col sm={6}>Transaction Status: Successful </Col>
                          <Col sm={6}>
                            Paid On:{' '}
                            {moment(
                              responsePurchaseCallbackData.purchasedOn
                            ).format('h:mma on MMM D, YYYY')}{' '}
                          </Col>
                        </Row>
                      </Alert>
                    ) : (
                      <Alert color="danger">
                        {responsePurchaseCallbackData.message ||
                          'There was error while processing your payment and adding responses'}
                      </Alert>
                    )}
                  </div>
                )}
              </div>
            )}

            {showResponseTable && (
              <div className="table-responsive">
                <div className="">
                  <TrivvyResponseCounter />
                </div>
                <Table>
                  <thead>
                    <th>Number of Responses</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Total</th>
                  </thead>
                  <tbody>
                    {tableData.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item.responses}</td>
                          <td>
                            {' '}
                            <PlusMinusInput
                              key={index}
                              value={item.quantity}
                              min={0}
                              max={10}
                              onChange={(val) =>
                                handleQuantityChanges(val, index)
                              }
                            />
                          </td>
                          <td> ${item.price}</td>
                          <td>$ {item.price * item.quantity}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </div>
            )}

            <div className="">
              <div>
                <TrivvySmsCounter />
              </div>

              <div className="mt-4">
                <div className="table-responsive">
                  <Table>
                    <thead>
                      <th>Number of SMS texts</th>
                      <th>Quantity</th>
                      <th>Price</th>
                      <th>Total</th>
                    </thead>
                    <tbody>
                      {tableDataSms.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.smsTexts}</td>
                            <td>
                              {' '}
                              <PlusMinusInput
                                key={index}
                                value={item.quantity}
                                min={0}
                                max={10}
                                onChange={(val) =>
                                  handleQuantityChangesSms(val, index)
                                }
                              />
                            </td>
                            <td> ${item.price}</td>
                            <td>$ {item.price * item.quantity}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>

            <Table>
              <thead>
                <tr>
                  <td>
                    <b>{getTotalResponses()} responses</b>
                  </td>
                  <td>
                    <b>{getTotalSmsTexts()} sms texts</b>
                  </td>
                  <td></td>
                  <td>
                    <b>${getTotalAmount()}</b>
                  </td>
                </tr>
              </thead>
            </Table>
          </div>
        )}
      </ModalBody>

      <ModalFooter>
        {!clientSecret && !paymentSuccess ? (
          <Button
            style={{}}
            className="trivia-action-button-main"
            onClick={managePurchase}
            disabled={!cartData.length}>
            Check out
          </Button>
        ) : (
          ''
        )}

        <Button
          size="sm"
          className="ml-2 trivia-action-button-main-secondary mr-5"
          onClick={() => onClose()}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

// const handleComplete = (data) => {
//   console.log("response_purchase_id", response_purchase_id);
//   if (response_purchase_id) {
//     // axios
//     //   .get(url.getStripeSessionStatus(stripe_session_id))
//     //   .then(({ data }) => {
//     //     const result = data.data;

//     //     if (result.status == "complete") {
//     setPaymentSuccess(true);
//     axios
//       .get(url.handlePurchaseSuccess(response_purchase_id))
//       .then(({ data }) => {
//         const result = data.data;

//         orgChangeSuccess(result.org);

//         setResponsePurchaseCallbackData({
//           success: true,
//           ...result.purchase,
//         });
//       })
//       .catch((err) => {
//         toastContainer("Error while increasing response limit", "error");

//         setResponsePurchaseCallbackData({
//           success: false,
//           message:
//             "Your payment was succesfull but error occured while adding the purchsed responses limit for your organization.",
//         });
//         console.log(err);
//       });
//     //   } else if (result.status == "open") {
//     //     axios
//     //       .get(url.handlePurchaseFailure(response_purchase_id))
//     //       .then(({ data }) => {
//     //         this.setState({
//     //           purchaseResponsesModal: true,
//     //           responsePurchaseCallbackData: {
//     //             success: false,
//     //             message: "Your payment has been failed, Please try again",
//     //           },
//     //         });
//     //       })
//     //       .catch((err) => {
//     //         toastContainer("Failed payment", "error");
//     //         console.log(err);
//     //       });
//     //   }
//     // })
//     // .catch((err) => {
//     //   toastContainer("Error getting payment session", "error");
//     //   console.log(err);
//     // });
//   }
// };
